import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["select", "options", "input", "description"]
    static values = { initialCount: Number }

    connect() {
        this.updateVisibility(this.initialCountValue)
        this.updateDescription()
    }

    selectionChanged() {
        this.updateVisibility(this.selectedIngredientCount)
        this.updateDescription()
    }

    modeChanged() {
        this.updateDescription()
    }

    get selectedIngredientCount() {
        return Array.from(this.selectTarget.selectedOptions).filter(option => option.value !== "").length
    }

    updateVisibility(selectedIngredientCount) {
        const hasMultipleIngredients = selectedIngredientCount > 1

        this.optionsTarget.classList.toggle("hidden", !hasMultipleIngredients)
        this.inputTargets.forEach((input) => {
            input.disabled = !hasMultipleIngredients
        })

        if (hasMultipleIngredients && !this.inputTargets.some((input) => input.checked)) {
            this.inputTargets.find((input) => input.value === "any").checked = true
        }
    }

    updateDescription() {
        const selectedMode = this.inputTargets.find((input) => input.checked)?.value

        if (selectedMode === "all") {
            this.descriptionTarget.textContent = "Products must contain every selected ingredient."
        } else {
            this.descriptionTarget.textContent = "Products can contain at least one selected ingredient."
        }
    }
}
